import React from 'react';
import { CLINICAL_CARD_STYLES, cardStyleLabel } from './clinicalOptions.js';

const selectClass =
    'w-full rounded-xl bg-slate-800/70 border border-white/10 px-3 py-2.5 text-sm text-white focus:outline-none focus:ring-2 focus:ring-teal-500/40';

const Field = ({ label, children }) => (
    <div>
        <label className="block text-[11px] font-medium uppercase tracking-wider text-slate-500 mb-1.5">{label}</label>
        {children}
    </div>
);

const ClinicalSettingsForm = ({ settings, onChange, showCardCount = true, maxCards = 20 }) => {
    const set = (key, value) => onChange({ ...settings, [key]: value });
    const range = maxCards - 1;

    return (
        <div className="rounded-2xl border border-white/10 bg-slate-900/40 p-4 sm:p-5">
            <h4 className="text-sm font-semibold text-white mb-4">Generation settings</h4>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <Field label="Card style">
                    <select className={selectClass} value={settings.cardStyle} onChange={(e) => set('cardStyle', e.target.value)}>
                        {CLINICAL_CARD_STYLES.map((o) => (
                            <option key={o} value={o}>
                                {cardStyleLabel(o, settings.examType)}
                            </option>
                        ))}
                    </select>
                </Field>
            </div>
            {showCardCount && (
                <div className="mt-5">
                    <div className="flex items-center justify-between mb-2">
                        <p className="text-xs font-medium uppercase tracking-wider text-slate-500">Number of cards</p>
                        <p className="text-sm font-semibold text-teal-300">{settings.cardCount}</p>
                    </div>
                    <div className="relative">
                        <div className="h-2 w-full rounded-full bg-slate-800/80" />
                        <div
                            className="absolute inset-y-0 left-0 h-2 rounded-full bg-gradient-to-r from-teal-500 to-emerald-500"
                            style={{ width: `${range > 0 ? ((Math.min(settings.cardCount, maxCards) - 1) / range) * 100 : 0}%` }}
                        />
                        <input
                            type="range"
                            min="1"
                            max={maxCards}
                            step="1"
                            value={Math.min(settings.cardCount, maxCards)}
                            onChange={(e) => set('cardCount', parseInt(e.target.value, 10))}
                            className="absolute inset-0 w-full h-8 opacity-0 cursor-pointer"
                            aria-label="Number of clinical flashcards"
                        />
                        <div
                            className="absolute -top-[6px] h-5 w-5 rounded-full bg-white shadow-lg shadow-teal-500/20 ring-4 ring-teal-500/30 pointer-events-none"
                            style={{ left: `calc(${range > 0 ? ((Math.min(settings.cardCount, maxCards) - 1) / range) * 100 : 0}% - 10px)` }}
                        />
                    </div>
                    <div className="mt-2 flex justify-between text-[11px] text-slate-500">
                        <span>1</span>
                        <span>{maxCards}</span>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ClinicalSettingsForm;
